/**
 * One reported figure.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists.
 */

import { readString } from '@/domain/json'
import { type DatapointSection } from '@/domain/section'
import DatapointBlock from '@/sections/datapoint/DatapointBlock.vue'
import DatapointInspector from '@/sections/datapoint/DatapointInspector.vue'
import type { SectionDefinition } from '@/sections/types'

export const datapointSection: SectionDefinition<'datapoint', DatapointSection> = {
  kind: 'datapoint',
  band: 'sustainability',

  icon: ['M3 12.5h10', 'M4.5 9.5V6', 'M8 9.5V3.5', 'M11.5 9.5V7.5', 'M3 3.5h1.6'],

  create: (id, title) => ({
    id,
    kind: 'datapoint',
    title,
    label: title,
    value: '',
    unit: '',
    comparative: '',
    period: '',
    comparativePeriod: '',
    method: '',
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'datapoint',
    title,
    label: readString(stored, 'label'),
    value: readString(stored, 'value'),
    unit: readString(stored, 'unit'),
    comparative: readString(stored, 'comparative'),
    period: readString(stored, 'period'),
    comparativePeriod: readString(stored, 'comparativePeriod'),
    method: readString(stored, 'method'),
  }),

  block: DatapointBlock,
  inspector: DatapointInspector,
}
